module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul>\n	<li>\n        <a href="/comps/create" class="secondary-btn button-outline">Create a comp</a>\n    </li>\n    <li>\n        <a href="/comps/join" class="secondary-btn button-outline">Join a comp</a>\n    </li>\n</ul>';
}
return __p;
};
